import { Integration, SystemAlertSchema } from "../../types";
import { ApiKeyForm } from "./ApiKeyForm";
import { CustomSetupForm } from "./CustomSetupForm";
import { OAuthSetupForm } from "./OAuthSetupForm";

type AuthForm = React.FC<{
  integration: Integration,
  onSubmit: (updatedIntegration: Integration) => void
}>;

const sentryForm: AuthForm = (data) => (
  <OAuthSetupForm
    regions={[
      { id: "us", label: "United States (US)" },
      { id: "de", label: "European Union (EU)" },
    ]}
    {...data}
  />
);

const datadogForm: AuthForm = (data) => (
  <OAuthSetupForm
    regions={[
      { id: "datadoghq.com", label: "US1" },
      { id: "us3.datadoghq.com", label: "US3" },
      { id: "us5.datadoghq.com", label: "US5" },
      { id: "datadoghq.eu", label: "EU1" },
      { id: "ap1.datadoghq.com", label: "AP1" },
      { id: "ap2.datadoghq.com", label: "AP2" },
      { id: "ddog-gov.com", label: "US1-FED" },
    ]}
    {...data}
  />
);

const coralogixForm: AuthForm = (data) => <ApiKeyForm id={"system-coralogix"} {...data} />;
const pagerDutyForm: AuthForm = (data) => <ApiKeyForm id={"system-pagerduty"} {...data} />;
const opsgenieForm: AuthForm = (data) => <ApiKeyForm id={"system-opsgenie"} {...data} />;
const prometheusForm: AuthForm = (data) => <ApiKeyForm id={"system-prometheus-alertmanager"} {...data} />;
const grafanaForm: AuthForm = (data) => <ApiKeyForm id={"system-grafana"} {...data} />;
const splunkForm: AuthForm = (data) => <ApiKeyForm id={"system-splunk"} {...data} />;
const cloudwatchForm: AuthForm = (data) => <ApiKeyForm id={"system-cloudwatch"} {...data} />;
const azureForm: AuthForm = (data) => <ApiKeyForm id={"system-azure-monitor"} {...data} />;
const gcpForm: AuthForm = (data) => <ApiKeyForm id={"system-gcp-monitoring"} {...data} />;
const newRelicForm: AuthForm = (data) => <ApiKeyForm id={"system-newrelic"} {...data} />;
const customForm: AuthForm = (data) => <CustomSetupForm {...data} />;

export const integrationSetupForm = {
  "system-coralogix": coralogixForm,
  "system-datadog": datadogForm,
  "system-sentry": sentryForm,
  "system-pagerduty": pagerDutyForm,
  "system-opsgenie": opsgenieForm,
  "system-prometheus-alertmanager": prometheusForm,
  "system-grafana": grafanaForm,
  "system-splunk": splunkForm,
  "system-cloudwatch": cloudwatchForm,
  "system-azure-monitor": azureForm,
  "system-gcp-monitoring": gcpForm,
  "system-newrelic": newRelicForm,
  "custom": customForm
} as const satisfies Record<SystemAlertSchema & "custom", AuthForm>;
